import { render } from "./batchDetailList.vue?vue&type=template&id=0aa33c34&scoped=true&ts=true"
import script from "./batchDetailList.vue?vue&type=script&lang=tsx"
export * from "./batchDetailList.vue?vue&type=script&lang=tsx"

import "./batchDetailList.vue?vue&type=style&index=0&id=0aa33c34&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/git_node_build_images_push_anjinq_test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aa33c34"]])

export default __exports__